export default class ContentModel {
    public type: string = null;
    public id: string = null;
    public label: string = null;
}
